<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="W3"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1ga22ua41vjj31hc0u0n0l.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1ga22ucrxxfj31hc0u07ea.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gdwkgcv9zej31hc0u0jvk.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1ga22uhv3p9j31hc0u0tco.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1gdwkgeua09j31hc0u0tb6.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1ga22uuqxw2j31hc0u00wt.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1ga22uxbz34j31hc0u076k.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1ga22v0gjpjj31hc0u0q7l.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1ga22v3f7rej31hc0u00yn.jpg"/>
        <img class="pro_img" src="https://wx4.sinaimg.cn/large/0067mezugy1ga22v62iwuj31hc0u0797.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1ga22vdpphaj31hc0u0jti.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1ga231o5kx3j30ku112mzc.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ga231qv51bj30ku112wj3.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1gdzh6vc6b8j30ku112777.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ga231vpn6gj30ku112ach.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1gdzh6y1krjj30ku112wg3.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1ga2326gru7j30ku11276p.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ga23297nphj30ku112myo.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1ga232c7vt3j30ku112jts.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1ga232es949j30ku112mzp.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ga232h8z06j30ku112q4l.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ga232pbfajj30ku112jt1.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
           
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/W/w3.vue